const HTI = "https://cdn.prod.website-files.com/624210d1dfbed884f69d0976";
const PS = "https://passportscan.b-cdn.net/wp-content/uploads";
const HP = "https://hostpointpos.com/showcase";

export const CATEGORIES = [
  { id: "all", label: "All Systems", testid: "product-tab-all" },
  { id: "proprietary", label: "HostPoint — In-House", testid: "product-tab-proprietary" },
  { id: "hti", label: "HTI Distribution", testid: "product-tab-hti" },
  { id: "partners", label: "Partners", testid: "product-tab-partners" },
];

export const PRODUCTS = [
  {
    id: "hostpoint-pos",
    testid: "product-card-hostpoint-pos",
    name: "HostPoint POS",
    category: "proprietary",
    badge: "In-House Flagship",
    tagline:
      "The all-in-one, KRA eTIMS-ready POS for restaurants, bars and hotels — sales, stock, staff and payments in one system.",
    description:
      "HostPoint POS is our own engineering: a cloud-based point of sale built in Nairobi for African hospitality. Every sale is fiscalised in real time with KRA eTIMS and printed with a verifiable KRA QR code, while M-Pesa STK, Pesapal and card terminals settle straight from the till. Run one outlet or a multi-property group from a single dashboard, with native Android & iOS apps for the floor.",
    features: [
      "M-Pesa STK, Pesapal & card terminals",
      "Real-time KRA eTIMS fiscal receipts",
      "QR scan-to-order guest menus",
      "Inventory, procurement & multi-outlet reports",
    ],
    highlights: [
      "KRA eTIMS (OSCU) certified — fiscal invoices, credit notes, X/Z reports and import reconciliation built in",
      "M-Pesa STK Push & C2B, Pesapal Cloud POS and Network International card terminals",
      "Branded QR scan-to-order menus — guests order and pay from their phone, no app needed",
      "Full inventory & procurement: suppliers, purchase orders, GRNs, requisitions and live valuation",
      "Staff roles, PIN login, shift open/close with a complete audit trail",
      "Native Android & iOS POS apps with on-device thermal receipt printing",
      "Multi-property and multi-outlet dashboards with group-level reporting",
    ],
    idealFor: ["Restaurants", "Bars & Lounges", "Hotels", "Cafés & QSR"],
    image: `${HP}/pos-menu.png`,
    gallery: [
      { src: `${HP}/pos-menu.png`, caption: "Fast tap-to-add POS with categories and modifiers" },
      { src: `${HP}/pos-invoice.png`, caption: "Build the order — tables, splits and grouped checkout" },
      { src: `${HP}/pos-settlement.png`, caption: "Settle any way they pay — M-Pesa, card or split tenders" },
      { src: `${HP}/etims.png`, caption: "KRA eTIMS management — every sale fiscalised in real time" },
      { src: `${HP}/dashboard.png`, caption: "Live business dashboard across every outlet" },
    ],
    link: "https://hostpointpos.com/",
  },
  {
    id: "hostpoint-retail",
    testid: "product-card-hostpoint-retail",
    name: "HostPoint Retail",
    category: "proprietary",
    badge: "In-House Flagship",
    tagline:
      "Retail POS, eCommerce and loyalty for fashion & lifestyle stores — KRA eTIMS ready across every outlet.",
    description:
      "HostPoint Retail brings our hospitality-grade engineering to fashion and lifestyle retail. Sell in store and online from one catalogue, manage every size and colour variant, reward loyal shoppers with points and tiers, and issue verifiable KRA fiscal receipts at every checkout — all reconciled in one workspace.",
    features: [
      "Size & colour variant inventory",
      "Built-in branded online store",
      "Loyalty points & customer app",
      "Fiscal receipts with KRA QR codes",
    ],
    highlights: [
      "Variant & matrix inventory — track every SKU by style, size and colour across stores",
      "Built-in eCommerce: launch a branded online store per tenant from the same catalogue",
      "Loyalty points, tiers and a customer mobile app to reward repeat shoppers",
      "KRA eTIMS fiscalised sales, credit notes and import reconciliation with retry-safe submission",
      "Cash, M-Pesa and card payments, including split tenders and terminal push-to-pay",
      "Real-time reports: best-sellers, margins and stock valuation across all outlets",
    ],
    idealFor: ["Fashion & Boutiques", "Lifestyle Stores", "Hotel Gift Shops", "Retail Chains"],
    image: "/assets/hostpoint-retail-receipt.png",
    gallery: [
      { src: "/assets/hostpoint-retail-receipt.png", caption: "KRA eTIMS fiscal receipt with scan-to-verify QR — issued at every checkout" },
    ],
    link: "https://hostpointretail.com/",
  },
  {
    id: "nebula-crs",
    testid: "product-card-nebula-crs",
    name: "nebula CRS",
    category: "hti",
    badge: "HTI Distribution",
    tagline:
      "World-class central reservations, channel management and booking engine for hotels and chains.",
    description:
      "nebula CRS is HTI's flagship central reservations system — a best-in-class, multi-property call-centre and rates platform with built-in channel management and the BookNow embedded booking engine. Trusted by major Southern African groups such as Tsogo Sun, Southern Sun, City Lodge and Legacy, it powers voice reservations, OTA distribution and direct bookings from one screen.",
    features: [
      "Multi-property call-centre reservations",
      "Channel manager — OTAs, GDS & bedbanks",
      "BookNow embedded booking engine",
    ],
    highlights: [
      "Best-in-breed voice / call-centre reservations for single or multi-property groups",
      "ChannelPrime PLUS distribution: Booking.com, Expedia, Airbnb, Hotelbeds, Sabre, Amadeus, Google Hotels and more",
      "BookNow 2.0 — a fully customisable booking engine embedded in your own website, no iframes",
      "Revenue rules engine: rate closeouts, inventory closeouts and stay restrictions",
      "Corporate Booker with secure agent logins, real-time bookings, payments and vouchers",
      "Integrated payments via NebulaPAY across CRS, booking engine, PMS and POS",
    ],
    idealFor: ["Hotel Groups & Chains", "Independent Hotels", "Lodges & Resorts", "Reservations Teams"],
    image: `${HTI}/62829186435ed85c77d05d5b_nebulaCRS-desktop.webp`,
    gallery: [
      { src: `${HTI}/62829186435ed85c77d05d5b_nebulaCRS-desktop.webp`, caption: "nebula CRS rates & availability — the call-centre workhorse" },
      { src: `${HTI}/631e07ed3bcb9c6e902adfd0_nebulacrs-screenshot22.webp`, caption: "Multi-property reservations at your agents' fingertips" },
      { src: `${HTI}/62cc33e77ef171731e3d7f00_channel-management22.gif`, caption: "Live channel management to OTAs, bedbanks and GDS" },
      { src: `${HTI}/62c472b79d9a677f4fa9f209_nebulaCRS-macbook.webp`, caption: "Channel management and voice reservations, anywhere" },
    ],
    link: "https://www.htihospitality.tech/",
  },
  {
    id: "nebula-pms",
    testid: "product-card-nebula-pms",
    name: "nebula PMS",
    category: "hti",
    badge: "HTI Distribution",
    tagline:
      "True-cloud property management for hotels, lodges and chains — reservations to night audit.",
    description:
      "nebula PMS is HTI's true-cloud property management system, hosted on Google Cloud Platform. It gives independent hotels and entire chains seamless access to reservations, guest accounting, housekeeping, conferencing and analytics from any device, anywhere — with a self-service build wizard that gets a new property live in minutes.",
    features: [
      "Front desk, housekeeping & maintenance",
      "Guest accounting & integrated payments",
      "Multi-property cloud reporting",
    ],
    highlights: [
      "True-cloud, multi-property PMS — one login for your whole chain, hosted on Google Cloud",
      "Guest accounting: folio management, deposits and front-office ledger with full auditability",
      "Housekeeping and maintenance workflows built for daily operations",
      "Conferencing, banqueting and activities management for events of any size",
      "Self check-in / check-out journeys with integrated payments",
      "Omni-channel reporting through AskNebula analytics and dashboards",
    ],
    idealFor: ["Hotels & Chains", "Lodges", "B&Bs & Guest Houses", "Boutique Resorts"],
    image: `${HTI}/6282b0ec22861d9038f8bf35_nebulapms-dashboard.webp`,
    gallery: [
      { src: `${HTI}/6282b0ec22861d9038f8bf35_nebulapms-dashboard.webp`, caption: "nebula PMS cloud dashboard — reservations, channels and guest accounting" },
    ],
    link: "https://www.htihospitality.tech/",
  },
  {
    id: "nebula-pos",
    testid: "product-card-nebula-pos",
    name: "nebula POS",
    category: "hti",
    badge: "HTI Distribution",
    tagline:
      "iOS & Android tablet point of sale with cloud stock control — built for dynamic F&B operations.",
    description:
      "nebula POS is HTI's cloud point of sale and stock-control platform for restaurants, bars and hotel F&B. Table-side ordering on iOS and Android tablets speeds up service and lifts revenue, while recipes, manufacturing and mobile stock takes keep your cost of sales honest — all integrated with nebula PMS for direct room posting.",
    features: [
      "Table-side ordering on tablets",
      "Recipes, stock control & mobile stock takes",
      "Guest self-ordering via Buzz app",
    ],
    highlights: [
      "iOS & Android tablet POS for table-side ordering, plus fixed TabletPOS terminals for QSR",
      "Cloud stock control with recipes, manufacturing and mobile stock takes — no third-party plug-ins",
      "Buzz guest-ordering web app: room service, beverages and meals from the guest's own phone",
      "Uber Eats and delivery-platform integrations",
      "Integrated card and QR payments via NebulaPAY",
      "Direct room-charge posting when paired with nebula PMS",
    ],
    idealFor: ["Restaurants & Bistros", "Hotel F&B Outlets", "Bars", "QSR & Delis"],
    image: `${HTI}/6282ac4df10baa19a6acaaf0_nebulapos-tablet22-isometric.webp`,
    gallery: [
      { src: `${HTI}/6282ac4df10baa19a6acaaf0_nebulapos-tablet22-isometric.webp`, caption: "TabletPOS — table-side ordering on iOS and Android" },
      { src: `${HTI}/67b9610e568424a6895f886b_5Mobile-Screens.avif`, caption: "The mobile POS experience across every screen" },
      { src: `${HTI}/636f56013958c9e46266e117_pos-graphic1-2023.webp`, caption: "Cloud POS and stock control for restaurants and bars" },
      { src: `${HTI}/67b963de89795b248f83f103_NebulaPOStablet2.avif`, caption: "Fast, touch-optimised ordering for busy service" },
    ],
    link: "https://www.htihospitality.tech/",
  },
  {
    id: "apex-pms",
    testid: "product-card-apex-pms",
    name: "Apex PMS",
    category: "hti",
    badge: "HTI Distribution",
    tagline:
      "Proven on-premise property management engine for hotels, resorts and remote lodges.",
    description:
      "Apex PMS is HTI's battle-tested on-premise property management system, refined over three decades of African hospitality. It is the dependable choice for properties where connectivity cannot be taken for granted — running front office, reservations and billing locally, while still integrating with Plus Point POS, NebulaPAY payments and the wider HTI ecosystem.",
    features: [
      "Fast check-in / check-out workflows",
      "Billing & payment gateway support",
      "Reliable in low-connectivity properties",
    ],
    highlights: [
      "On-premise reliability — full front office keeps running even when the internet doesn't",
      "Reservations, guest billing, folios and night audit in one proven system",
      "Integrated with Plus Point POS & Stock for outlet-to-room posting",
      "NebulaPAY integrated payments at the front desk",
      "Backed by HTI's 30+ years of hotel technology and Hostech's local support desk",
      "Ideal bridge product: pair with nebula CRS for cloud distribution",
    ],
    idealFor: ["Remote Lodges", "Independent Hotels", "Resorts", "Low-Connectivity Properties"],
    image: null,
    gallery: [],
    link: "https://www.htihospitality.tech/",
  },
  {
    id: "pluspoint-pos",
    testid: "product-card-pluspoint-pos",
    name: "Plus Point POS",
    category: "hti",
    badge: "HTI Distribution",
    tagline:
      "Robust, time-tested food & beverage terminal solution for high-volume hotel outlets.",
    description:
      "Plus Point POS is HTI's robust on-premise point of sale and stock system for high-volume food & beverage operations. Deployed across hotel groups and resort F&B outlets for years, it handles split bills, tabs and rapid service with ease — posting charges straight to guest rooms in Apex PMS or nebula PMS.",
    features: [
      "Seamless HTI PMS room posting",
      "Split bills, tabs & table transfers",
      "Shift reports & full audit trail",
    ],
    highlights: [
      "High-volume F&B terminals built for busy hotel restaurants and bars",
      "Integrated stock control for outlets, stores and cost centres",
      "Room-charge posting to Apex PMS and nebula PMS guest folios",
      "Split bills, bar tabs, table transfers and course management",
      "Shift closeouts, X/Z readings and a complete audit trail",
      "NebulaPAY integrated card payments at the terminal",
    ],
    idealFor: ["Hotel Restaurants", "High-Volume Bars", "Resorts", "Banqueting Operations"],
    image: null,
    gallery: [],
    link: "https://www.htihospitality.tech/",
  },
  {
    id: "passportscan",
    testid: "product-card-passportscan",
    name: "PassportScan",
    category: "partners",
    badge: "Distribution Partner",
    tagline:
      "Digital check-in that scans guest IDs, captures signatures and syncs straight into your PMS.",
    description:
      "PassportScan Cloud digitises guest identification at check-in: scan any passport or ID in about a second, capture digital signatures and privacy consents, and push everything straight into your PMS. Trusted by more than 6,500 hotels worldwide — including Hilton, Marriott, Accor and Wyndham — it installs in under an hour on devices you already own.",
    features: [
      "1-second passport & ID OCR scanning",
      "Digital signature & consent capture",
      "Trusted by 6,500+ hotels worldwide",
    ],
    highlights: [
      "Scan passports and IDs in ~1 second with accurate OCR/MRZ reading",
      "Digital signature capture for registration cards and privacy consents",
      "Self check-in and kiosk modes to eliminate front-desk queues",
      "Automatic guest-profile sync with leading PMS platforms (Oracle Opera, Mews, protel and more)",
      "Police, government and national statistics integrations where required",
      "GDPR-compliant, encrypted and secure by design",
      "Free activation, pay-per-use pricing, works on any device — live in under an hour",
    ],
    idealFor: ["Hotels & Resorts", "Lodges & Camps", "Serviced Apartments", "Hostels & B&Bs"],
    image: `${PS}/2024/04/0_passportscan-1.png`,
    gallery: [
      { src: `${PS}/2024/04/0_passportscan-1.png`, caption: "PassportScan Cloud — the check-in revolution" },
      { src: `${PS}/2024/04/2_passportscan.png`, caption: "Scan ID documents quickly and securely" },
      { src: `${PS}/2024/04/3_passportscan.png`, caption: "Automatic data transfer straight into your PMS" },
      { src: `${PS}/2024/04/4_passportscan.png`, caption: "Digital signature capture on tablet or mobile" },
      { src: `${PS}/2026/02/Tavola-disegno-13passportscan_HOME.png`, caption: "Works on any device your front desk already uses" },
    ],
    link: "https://www.passportscan.net/",
  },
];
